/* eslint-disable prefer-destructuring,func-names,react/prop-types  */
import React, { Component } from 'react';
import { Spin } from 'antd';
import sc from 'styled-components';

const StyledSpinner = sc(Spin)`
  text-align: center;
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
`;

const IFrameWrapper = sc.div`
display: flex;
flex-direction: column;
flex-grow: 1;
iframe {
  flex-grow: 1
}
`;

const API_URL = process.env.API_URL; // eslint-disable-line
const PLAYER_URL = process.env.PLAYER_URL;

export default (bottle) => {
  bottle.constant('mediaServicesURI', `${API_URL}`);

  bottle.factory(
    'MediaBrowserContainer',
    ({ MediaBrowserView, mediaServicesURI }) => class MediaBrowserContainer extends Component {
      constructor(props) {
        super(props);
        this.state = { data: false, editVisible: false };
        this.onOpenDrawer = this.onOpenDrawer.bind(this);
        this.onCloseDrawer = this.onCloseDrawer.bind(this);
        this.onSelectMedia = this.onSelectMedia.bind(this);
      }

      componentDidMount() {
        this.props.fetchMediaList(); // eslint-disable-line
      }

      onSelectMedia(value) {
        this.onOpenDrawer(value);
        this.props.fetchMediaItem(value.currentTarget.dataset.id);
      }

      onOpenDrawer() {
        this.setState({ editVisible: true });
      }

      onCloseDrawer() {
        this.setState({ editVisible: false });
      }

      get goHome() {
        return () => {
          this.props.history.push('/');
        };
      }

      get isLoading() {
        return this.props.loading;
      }

      render() {
        const {
          lastError,
          bearerToken,
          allMedia,
          mediaId,
        } = this.props;

        const {
          editVisible,
        } = this.state;

        const playerConfig = {
          searchTimeRanges: '',
          analyticsFormat: 'ANALYTICS_SCHEMA_VERSION_V3',
          mediaId,
          height: true,
          token: bearerToken,
          apiUrl: mediaServicesURI,
        };

        const entries =
          Object.keys(playerConfig)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(playerConfig[k])}`)
            .join('&');

        const computedURL = `${PLAYER_URL}/index.html?index=0#${entries}`;

        return (
          <MediaBrowserView
            title="Media Browser"
            dataSource={allMedia}
            lastError={lastError}
            goHome={this.goHome}
            onSelect={this.onOpenDrawer}
            onPlayMedia={this.onSelectMedia}
            onCloseDrawer={this.onCloseDrawer}
            editVisible={editVisible}
            currentMedia={mediaId}
            isLoading={this.isLoading}
          >
            { !mediaId && <StyledSpinner size="large" />}
            { editVisible && mediaId && (
            <IFrameWrapper>
              <iframe
                title="Player"
                style={{
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    flexGrow: 1,
                  }}
                src={computedURL}
              />
            </IFrameWrapper>
            ) }
          </MediaBrowserView>
        );
      }
    },
  );
};
